module.exports = __webpack_public_path__ + "img/makeup.ce0aa5ad.png";